import { Component, OnInit } from '@angular/core';
import { LoggerStoreService } from './services/logger/logger-store.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    host: { 'class': 'mst' }
})
export class AppComponent implements OnInit {

    constructor(
        private loggerStoreService: LoggerStoreService) { }

    ngOnInit() {
        this.loggerStoreService.log('App component initialised.');
    }

}
